import { LocationsDocuments } from "@/pages/locaties/documenten"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/locaties/$locationId/documenten/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "locations"),
})

function RouteComponent() {
  const { locationId } = useParams({
    from: "/beheer/locaties/$locationId",
  })

  return <LocationsDocuments locationId={Number(locationId)} />
}
